import { DateRangeInterface } from '~/attendee/components/shared/date-range-input/date-range-input.component';

import { QueryParamsFilterEnum } from './query-params-filter.enum';

export function getFormatedSearchParams({
  city,
  radius,
  dateRange,
  sportsGroup,
  placeId,
}: {
  city: string;
  dateRange: DateRangeInterface;
  placeId?: string;
  radius: number;
  sportsGroup: number;
}): { field: string; value: string }[] {
  if (dateRange?.from) {
    dateRange.from.setHours(0, 0, 0);
  }

  if (dateRange?.to) {
    dateRange.to.setHours(23, 59, 59);
  }

  return [
    {
      field: QueryParamsFilterEnum.CITY_FILTER_NAME,
      value: city,
    },
    {
      field: QueryParamsFilterEnum.RADIUS_FILTER_NAME,
      value: radius?.toString(),
    },
    {
      field: QueryParamsFilterEnum.START_DATE_FILTER_NAME,
      value: dateRange?.from?.toISOString(),
    },
    {
      field: QueryParamsFilterEnum.END_DATE_FILTER_NAME,
      value: dateRange?.to?.toISOString(),
    },
    {
      field: QueryParamsFilterEnum.SPORT_GROUPS_FILTER_NAME,
      value: sportsGroup ? `${sportsGroup}` : undefined,
    },
    {
      field: QueryParamsFilterEnum.PLACE_ID_FILTER_NAME,
      value: placeId || undefined,
    },
  ];
}
